import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Grid,
    TextField,
    makeStyles,
    Container,
    Button,
    CardContent,
    Divider,
    InputLabel,
    CardHeader,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import _ from 'lodash';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
    DatePicker,
} from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import tokenDecoder from '../../../../utils/tokenDecoder';
import { AlertDialogWithoutButton } from 'src/views/Common/AlertDialogWithoutButton';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: 'red'
    },
    colorRecord: {
        backgroundColor: 'green'
    }
}));

const screenCode = 'BANKRECONCILIATIONREPORT';

export default function BankReconciliationReport(props) {
    const [title, setTitle] = useState('Bank Reconciliation Report');
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [GroupList, setGroupList] = useState([]);
    const [FactoryList, setFactoryList] = useState([]);
    const [bankReconciliationDetails, setBankReconciliationDetails] = useState({
        groupID: 0,
        factoryID: 0,
        tranLedgerAccountID: 0,
        year: new Date().getUTCFullYear().toString(),
        month: (new Date().getUTCMonth() + 1).toString().padStart(2, '0'),
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const navigate = useNavigate();
    const alert = useAlert();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const componentRef = useRef();
    const [reconciliationRegisterdData, setReconciliationRegisterdData] = useState([]);
    const [creditArray, setCreditArray] = useState([]);
    const [debitArray, setDebitArray] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [totalDebitAmount, setTotalDebitAmount] = useState(0);
    const [totalCreditAmount, setTotalCreditAmount] = useState(0);
    const [openingBalance, setOpeningBalance] = useState(0);
    const [totalClosingBalance, setTotalClosingBalance] = useState([]);
    const [tranLedgerList, setTranLedgerList] = useState([]);
    const [isReportAvailabale, setIsReportAvailable] = useState(false);
    const [banksAuto, setBanksAuto] = useState();
    const [isReconciliationCompleted, setIsReconciliationCompleted] = useState(false);
    const [completedReconciliation, setcompletedReconciliation] = useState({});
    const [dialog, setDialog] = useState(false);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: 0,
        factoryID: 0,
        tranLedgerAccountID: 0,
        month: '',
        year: '',
        groupName: '',
        factoryName: '',
        accountType: ''
    });
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const transactionModeLookup = {
        1: 'Main Cash',
        2: 'General Cash',
        3: 'Cheque',
        4: 'Income Invoice',
        5: 'Supplier Invoice',
        6: 'Provision',
        7: 'Transfer',
        998: 'Advance Payment Bank',
        999: 'Advance Payment Cheque'
    };

    useEffect(() => {
        getGroupsForDropdown();
        getPermission();
    }, []);

    useEffect(() => {
        getfactoriesForDropDown();
    }, [bankReconciliationDetails.groupID]);

    useEffect(() => {
        setReconciliationRegisterdData([])
        setDebitArray([])
        setCreditArray([])
        setTotalDebitAmount(0)
        setTotalCreditAmount(0)
        setIsReportAvailable(false)
    }, [bankReconciliationDetails.tranLedgerAccountID]);

    useEffect(() => {
        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            tranLedgerAccountID: 0,
            year: new Date().getUTCFullYear().toString(),
            month: (new Date().getUTCMonth() + 1).toString().padStart(2, '0'),
        });
    }, [bankReconciliationDetails.factoryID, bankReconciliationDetails.groupID]);

    useEffect(() => {
        trackPromise(getTranLedgerListForDropdownAuto(), getTranLedgerList());
    }, [bankReconciliationDetails.factoryID]);

    useEffect(() => {
        setReconciliationRegisterdData([]);
    }, [bankReconciliationDetails.groupID, bankReconciliationDetails.factoryID, bankReconciliationDetails.tranLedgerAccountID, bankReconciliationDetails.year, bankReconciliationDetails.month]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(
            p => p.permissionCode == 'VIEWBANKRECONCILIATIONREPORT'
        );

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(
            p => p.permissionCode === 'GROUPDROPDOWN'
        );
        var isFactoryFilterEnabled = permissions.find(
            p => p.permissionCode === 'FACTORYDROPDOWN'
        );

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        });
    }

    async function getGroupsForDropdown() {
        const groups = await services.getGroupsForDropdown();
        setGroupList(groups);
    }

    async function getfactoriesForDropDown() {
        const factory = await services.getfactoriesForDropDown(
            bankReconciliationDetails.groupID
        );
        setFactoryList(factory);
    }

    async function getTranLedgerListForDropdownAuto() {
        const banksResults = await services.getTranLedgerListForDropdownAuto(bankReconciliationDetails.factoryID);
        setBanksAuto(banksResults);
    }

    function handleSearchDropdownChangeFieldsBankAccounts(data, e) {
        if (data === undefined || data === null) {
            setBankReconciliationDetails({
                ...bankReconciliationDetails,
                tranLedgerAccountID: '0'
            });
            return;
        } else {
            var valueV = data["ledgerAccountID"];
            setBankReconciliationDetails({
                ...bankReconciliationDetails,
                tranLedgerAccountID: valueV
            });
        }
    }

    async function getTranLedgerList() {
        const transaction = await services.getTranLedgerListForDropdown(bankReconciliationDetails.factoryID);
        setTranLedgerList(transaction);
    }

    async function GetCropDetails() {
        let model = {
            groupID: parseInt(bankReconciliationDetails.groupID),
            factoryID: parseInt(bankReconciliationDetails.factoryID),
            ledgerAccountID: parseInt(bankReconciliationDetails.tranLedgerAccountID),
            year: bankReconciliationDetails.year.toString(),
            month: bankReconciliationDetails.month.toString(),
        };
        getSelectedDropdownValuesForReport(model);
        const registerData = await services.GetBankReconciliationReport(model);
        trackPromise(GetReconciliationClosingBalance());

        if (registerData.statusCode == 'Success') {
            setReconciliationRegisterdData(registerData.data.reconciliationDataList);
            let totalCreditAmount = 0;
            let totalDebitAmount = 0;
            if (creditArray.length === 0 && debitArray.length === 0) {
                registerData.data.reconciliationDataList.forEach(item => {
                    if (item.debit === 0) {
                        creditArray.push(item);
                    }
                    if (item.credit === 0) {
                        debitArray.push(item);
                    }
                });
            }
            registerData.data.reconciliationDataList.forEach(item => {
                if (item.debit === 0) {
                    totalCreditAmount += item.credit;
                }
                if (item.credit === 0) {
                    totalDebitAmount += item.debit;
                }
            });
            setTotalCreditAmount(totalCreditAmount);
            setTotalDebitAmount(totalDebitAmount);
            setIsReportAvailable(true);
            const currentBalance = await services.GetReconciliationClosingBalance(model);
            if (currentBalance.statusCode === 'Success' && currentBalance.data != null) {
                let totalOpeningDebit = parseFloat(currentBalance.data.totalDebit) || 0;
                let totalOpeningCredit = parseFloat(currentBalance.data.totalCredit) || 0;
                const currentOpeningBalance = totalOpeningDebit - totalOpeningCredit;
                setOpeningBalance(currentOpeningBalance);
            } else {
                alert.error('Error');
            }
            //createDataForExcel(reconciliationRegisterdData.data);
            if (registerData.data.isCompleted) {
                setIsReconciliationCompleted(true);
                setcompletedReconciliation(registerData.data);
            } else {
                setIsReconciliationCompleted(false);
            }
        } else if (registerData.statusCode == 'Error') {
            setReconciliationRegisterdData([]);
            setIsReportAvailable(true);
            setIsReconciliationCompleted(false);
            if(registerData.data === -1){
                setIsReportAvailable(false);
                alert.error(registerData.message);
            }
        }
        else {
            setReconciliationRegisterdData([]);
            alert.error('No Record to Display');
        }
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setSelectedSearchValues({
            ...selectedSearchValues
        });
        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            [e.target.name]: value
        });
        setReconciliationRegisterdData([]);
    }

    function handleDateChange(date) {
        let monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        var month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        var year = date.getUTCFullYear();
        let monthName = monthNames[month - 1];
        setSelectedSearchValues({
            ...selectedSearchValues,
            monthName: monthName
        });
        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            month: month.toString(),
            year: year.toString()
        });

        setSelectedDate(date);
        clearTable();
    }

    function handleChangeForm(e) {
        const target = e.target;
        const value = target.value;
        setBankReconciliationDetails({
            ...bankReconciliationDetails,
            [e.target.name]: value
        });
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        );
    }

    function getSelectedDropdownValuesForReport(searchModel) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            factoryName: FactoryList[searchModel.factoryID],
            accountType: tranLedgerList[searchModel.ledgerAccountID]
        });
    }

    async function createFile() {
        var file = await createDataForExcel(reconciliationRegisterdData);
        var settings = {
            sheetName: 'Bank Reconciliation Report',
            fileName:
                'Bank Reconciliation Report - ' +
                selectedSearchValues.groupName +
                ' ' +
                selectedSearchValues.factoryName +
                ' ' +
                selectedSearchValues.year +
                ' - ' +
                selectedSearchValues.month
        };
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Cheque Number': x.transactionModeID,
                    'Cheque Date': x.date.split('T')[0],
                    'Voucher Date': x.date.split('T')[0],
                    'Voucher Number': x.referenceNumber,
                    'Narration': x.description,
                    'Amount': x.credit,
                };
                res.push(vr);
            });
            var vr = {
                'Date': selectedSearchValues.accountType,
                'Amount': ""
            }
            res.push(vr);
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(reconciliationRegisterdData);
        var settings = {
            sheetName: 'Bank Reconciliation Report',
            fileName:
                'Bank Reconciliation Report -' +
                selectedSearchValues.year +
                ' - ' +
                selectedSearchValues.month
        };

        let keys = Object.keys(file[0]);
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem });
        });

        let dataA = [
            {
                sheet: 'Bank Reconciliation Report',
                columns: tempcsvHeaders,
                content: file
            }
        ];
        xlsx(dataA, settings);
    }

    async function GetReconciliationClosingBalance() {
        let model = {
            groupID: parseInt(bankReconciliationDetails.groupID),
            factoryID: parseInt(bankReconciliationDetails.factoryID),
            ledgerAccountID: parseInt(bankReconciliationDetails.tranLedgerAccountID),
            year: bankReconciliationDetails.year.toString(),
            month: bankReconciliationDetails.month.toString(),
        };
        const currentBalance = await services.GetReconciliationClosingBalance(model);
        if (currentBalance.statusCode === 'Success' && currentBalance.data != null) {
            let totalOpeningDebit = parseFloat(currentBalance.data.totalDebit) || 0;
            let totalOpeningCredit = parseFloat(currentBalance.data.totalCredit) || 0;

            const currentOpeningBalance = totalOpeningDebit - totalOpeningCredit;
            setOpeningBalance(currentOpeningBalance);

        } else {
            alert.error('Error');
        }
    }

    function clearTable() {
        setReconciliationRegisterdData([]);
        setCreditArray([]);
        setDebitArray([]);
        setTotalDebitAmount(0);
        setTotalCreditAmount(0);
        setOpeningBalance(0);
        setIsReportAvailable(false);
    }

    async function completeReconciliation() {
        let completedData = {
            groupID: bankReconciliationDetails.groupID,
            factoryID: bankReconciliationDetails.factoryID,
            factoryName: selectedSearchValues.factoryName,
            year: bankReconciliationDetails.year,
            month: bankReconciliationDetails.month,
            openingBalance: openingBalance,
            ledgerAccountID: bankReconciliationDetails.tranLedgerAccountID,
            reconciliationDataList: [...creditArray, ...debitArray],
            createdBy: tokenDecoder.getUserIDFromToken()
        }
        const response = await services.SaveReconciliationCompleteData(completedData);
        if (response.statusCode === "Success") {
            setIsReconciliationCompleted(true);
            alert.success(response.message);
        } else {
            alert.error(response.message);
        }
    }

    async function cancelRequest() {
        setDialog(false);
    }

    async function confirmRequest() {
        completeReconciliation();
    }

    async function Confirmation() {
        setDialog(true);
    }

    return (
        <Fragment>
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: bankReconciliationDetails.groupID,
                            factoryID: bankReconciliationDetails.factoryID,
                            tranLedgerAccountID: bankReconciliationDetails.tranLedgerAccountID,
                        }}
                        validationSchema={Yup.object().shape({
                            groupID: Yup.number()
                                .required('Group is required')
                                .min('1', 'Group is required'),
                            factoryID: Yup.number()
                                .required('Factory is required')
                                .min('1', 'Factory is required'),
                            tranLedgerAccountID: Yup.number().
                                required('Ledger Account is required')
                                .min('1', 'Ledger Account is required'),
                        })}
                        onSubmit={() => trackPromise(GetCropDetails())}
                        enableReinitialize
                    >
                        {({ errors, handleBlur, handleSubmit, touched }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader title={cardTitle(title)} />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={e => handleChange(e)}
                                                            value={bankReconciliationDetails.groupID}
                                                            variant="outlined"
                                                            id="groupID"
                                                            size='small'
                                                            disabled={!permissionList.isGroupFilterEnabled}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(GroupList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(
                                                                touched.factoryID && errors.factoryID
                                                            )}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={e => handleChange(e)}
                                                            value={bankReconciliationDetails.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            size='small'
                                                            disabled={!permissionList.isFactoryFilterEnabled}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(FactoryList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <DatePicker
                                                                autoOk
                                                                variant="inline"
                                                                openTo="month"
                                                                views={["year", "month"]}
                                                                label="Year and Month *"
                                                                helperText="Select applicable month"
                                                                value={selectedDate}
                                                                disableFuture={true}
                                                                onChange={date => handleDateChange(date)}
                                                                size="small"
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item md={4} xs={12} style={{ marginTop: '-1%' }}>
                                                        <InputLabel shrink id="tranLedgerAccountID">
                                                            Bank Account *
                                                        </InputLabel>
                                                        <Autocomplete
                                                            id="tranLedgerAccountID"
                                                            options={banksAuto || []}
                                                            getOptionLabel={(option) => option?.ledgerAccountName
                                                                || "Unnamed Bank"}
                                                            onChange={(e, value) => handleSearchDropdownChangeFieldsBankAccounts(value, e)}
                                                            value={
                                                                banksAuto?.find(
                                                                    (option) => option.ledgerAccountID === bankReconciliationDetails.tranLedgerAccountID
                                                                ) || null
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    name="tranLedgerAccountID"
                                                                    fullWidth
                                                                    size="small"
                                                                    placeholder="--Select Account Type Name --"
                                                                    onBlur={handleBlur}
                                                                    error={Boolean(touched.tranLedgerAccountID && errors.tranLedgerAccountID)}
                                                                    helperText={touched.tranLedgerAccountID && errors.tranLedgerAccountID}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                </Grid>
                                                <Box display="flex" flexDirection="row-reverse" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                        size='small'
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                            {isReportAvailabale ? (
                                                <PerfectScrollbar>
                                                    <Box
                                                        minWidth={1050}
                                                        style={{ border: '1px solid black' }}
                                                    >
                                                        <h2 style={{ textAlign: 'center', marginTop: '2%' }}>
                                                            <span> Bank Reconciliation Statement </span>
                                                        </h2>
                                                        <h3 style={{ textAlign: 'center' }}>
                                                            <span>{'Factory : ' + selectedSearchValues.factoryName} </span>
                                                        </h3>
                                                        <br></br>
                                                        <h4 style={{ textAlign: 'left', marginLeft: '2%' }}>
                                                            <span>
                                                                {'Bank Account: ' + selectedSearchValues.accountType}
                                                            </span>
                                                            <br></br>
                                                            <span>
                                                                {'Period: ' + bankReconciliationDetails.month + ' / ' + bankReconciliationDetails.year}
                                                            </span>
                                                        </h4>

                                                        <br></br>
                                                        <h4 style={{ textAlign: 'right', padding: '6px' }}>
                                                            <span>
                                                                {'Cash Book Closing Balance : ' +
                                                                    (isReconciliationCompleted ?
                                                                        (completedReconciliation?.openingBalance ?? 0) :
                                                                        (openingBalance ?? 0)
                                                                    ).toLocaleString('en-US', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                            </span>
                                                        </h4>
                                                    </Box>
                                                    <Box minWidth={1050}>
                                                        <TableContainer >
                                                            <Table aria-label="caption table" style={{ border: "1px black solid" }}>
                                                                <TableHead >
                                                                    <TableRow style={{ border: "1px black gray", width: "100%" }}>
                                                                        <TableCell align={'right'} fontWeight={'bold'}>Mode of Transaction</TableCell>
                                                                        <TableCell align={'right'} fontWeight={'bold'}>Cheque Number</TableCell>
                                                                        <TableCell align={'right'}>Cheque Date</TableCell>
                                                                        <TableCell align={'right'}>Voucher Date</TableCell>
                                                                        <TableCell align={'right'}>Voucher Number</TableCell>
                                                                        <TableCell align={'right'}>Narration</TableCell>
                                                                        <TableCell align={'right'}>Amount</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableCell align={'left'} style={{ fontWeight: 'bold' }}> Unpresented cheques </TableCell>
                                                                <TableBody>
                                                                    {creditArray.map((data, index) => (
                                                                        <>
                                                                            <TableRow key={index}>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {transactionModeLookup[data.modeoftransactionID ? data.modeoftransactionID : 0]}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.chequeNumber ? data.chequeNumber : '-'}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.date.split("T")[0]}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.date.split("T")[0]}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.referenceNumber}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.narration ? data.narration : '-'}

                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {(data.credit).toLocaleString('en-US', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </>
                                                                    ))}
                                                                    <TableRow>
                                                                        <TableCell align={'left'} style={{ fontWeight: 'bold' }}>
                                                                        </TableCell>
                                                                        <TableCell align={'left'} colSpan={5} style={{ fontWeight: 'bold' }}>
                                                                        </TableCell>
                                                                        <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                            {(totalCreditAmount).toLocaleString('en-US', {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })}
                                                                        </TableCell>
                                                                    </TableRow>

                                                                    <TableCell align={'left'} style={{ fontWeight: 'bold' }}> Unrealized cheques </TableCell>
                                                                    {debitArray.map((data, index) => (
                                                                        <>
                                                                            <TableRow key={index} >
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {transactionModeLookup[data.modeoftransactionID ? data.modeoftransactionID : 0]}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.chequeNumber ? data.chequeNumber : '-'}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.date.split("T")[0]}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.date.split("T")[0]}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.referenceNumber}
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {data.description ? data.description : '-'}

                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align={'right'}
                                                                                    component="th"
                                                                                    scope="row"
                                                                                    style={{ borderBottom: 'none' }}
                                                                                >
                                                                                    {(data.debit).toLocaleString('en-US', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2
                                                                                    })}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </>
                                                                    ))}
                                                                    <TableRow>
                                                                        <TableCell align={'left'} style={{ fontWeight: 'bold' }}>

                                                                        </TableCell>
                                                                        <TableCell align={'left'} colSpan={5} style={{ fontWeight: 'bold' }}>

                                                                        </TableCell>
                                                                        <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                            {totalDebitAmount.toLocaleString('en-US', {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow >
                                                                        <TableCell align={'left'} style={{ fontWeight: 'bold' }}>
                                                                            Total Amount
                                                                        </TableCell>
                                                                        <TableCell align={'left'} colSpan={5} style={{ fontWeight: 'bold' }}>
                                                                        </TableCell>
                                                                        <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                            {(totalCreditAmount - totalDebitAmount).toLocaleString('en-US', {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align={'left'} style={{ fontWeight: 'bold' }}>
                                                                            Bank Statement Closing Balance
                                                                        </TableCell>
                                                                        <TableCell align={'left'} colSpan={5} style={{ fontWeight: 'bold' }}>
                                                                        </TableCell>
                                                                        <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                            {(isReconciliationCompleted ?
                                                                                (completedReconciliation?.openingBalance ?? 0) + (totalCreditAmount - totalDebitAmount) :
                                                                                (openingBalance ?? 0) + (totalCreditAmount - totalDebitAmount)).toLocaleString('en-US', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Box>
                                                </PerfectScrollbar>
                                            ) : null}
                                            {isReportAvailabale ? (
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    {/* <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        type="submit"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorRecord}
                                                        onClick={() => createFile()}
                                                        size='small'
                                                    >
                                                        EXCEL
                                                    </Button> */}
                                                    {!isReconciliationCompleted && (
                                                        <Button
                                                            color="primary"
                                                            id="btnRecord"
                                                            type="button"
                                                            variant="contained"
                                                            style={{ marginRight: '1rem' }}
                                                            onClick={() => Confirmation()}
                                                            size='small'
                                                        >
                                                            Complete
                                                        </Button>
                                                    )}
                                                    <ReactToPrint
                                                        documentTitle={'Bank Reconciliation Report'}
                                                        trigger={() => (
                                                            <Button
                                                                color="primary"
                                                                id="btnRecord"
                                                                type="submit"
                                                                variant="contained"
                                                                style={{ marginRight: '1rem' }}
                                                                className={classes.colorCancel}
                                                                size='small'
                                                            >
                                                                PDF
                                                            </Button>
                                                        )}
                                                        content={() => componentRef.current}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePDF
                                                            ref={componentRef}
                                                            reconciliationRegisterdData={reconciliationRegisterdData}
                                                            searchData={selectedSearchValues}
                                                            debitArray={debitArray}
                                                            creditArray={creditArray}
                                                            totalDebitAmount={totalDebitAmount}
                                                            totalCreditAmount={totalCreditAmount}
                                                            openingBalance={openingBalance}
                                                            bankReconciliationDetails={bankReconciliationDetails}
                                                            totalClosingBalance={totalClosingBalance}
                                                            completedReconciliation= {completedReconciliation}
                                                            isReconciliationCompleted = {isReconciliationCompleted}
                                                        />
                                                    </div>
                                                </Box>
                                            ) : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
                {dialog ?
                    <AlertDialogWithoutButton confirmData={confirmRequest} cancelData={cancelRequest}
                        headerMessage={"Finalize Bank Reconciliation Report"}
                        discription={"Are you sure you want to FINALIZE and lock this reconciliation?"} />
                    : null
                }
            </Page>
        </Fragment>
    );
}
